var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberSix = function SvgIconNumberSix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.359 3.513a1 1 0 1 0-1.717-1.026L6.697 12.44a6.25 6.25 0 1 0 4.005-2.805zM8.304 13.65l.008-.012.085-.143a4.25 4.25 0 1 1-.093.155",
    clipRule: "evenodd"
  })));
};
export default SvgIconNumberSix;